import React from 'react'
import { FaFacebookSquare, FaLinkedin, FaInstagramSquare, FaYoutubeSquare } from 'react-icons/fa';

const SharedIconComponent = (links) => {
  return(
    <>
      {links && links.links && links.links.linkedin && <a href={links.links.linkedin} target="_blank" rel="noreferrer"><FaLinkedin /></a>}
      {links && links.links && links.links.youtube && <a href={links.links.youtube} target="_blank" rel="noreferrer"><FaYoutubeSquare /></a>}
      {links && links.links && links.links.facebook && <a href={links.links.facebook} target="_blank" rel="noreferrer"><FaFacebookSquare /></a>}
      {links && links.links && links.links.instagram && <a href={links.links.instagram} target="_blank" rel="noreferrer"><FaInstagramSquare /></a>}
    </>
  );
}

export default SharedIconComponent;
